import createActionType from '../core/createActionType';
import { NAME } from './constants';

export const GET_SOURCE_STATS_BE_DATE_RANGE = createActionType(`${NAME}/GET_SOURCE_STATS_BE_DATE_RANGE`);
export const GET_YEARLY_SOURCE_STATS  = createActionType(`${NAME}/GET_YEARLY_SOURCE_STATS`);
export const SOURCE_CHANGED  = createActionType(`${NAME}/SOURCE_CHANGED`);
export const MEASUREMENT_CHANGED  = createActionType(`${NAME}/MEASUREMENT_CHANGED`);
export const TRIAL_CREATED  = createActionType(`${NAME}/TRIAL_CREATED`);